import {useEffect} from 'react';

import {oneOfType, node, func} from 'prop-types';
import {useNavigate} from 'react-router-dom';

import {APP_ROUTES} from '../const';
import usePayment from '../hooks/providers/usePayment';

const RequireUserNotToBeGuest = ({children}) => {
  const navigate = useNavigate();
  const {isGuest} = usePayment();

  useEffect(() => {
    if (isGuest) {
      navigate(APP_ROUTES.connections);
    }
  }, [isGuest]);

  return children;
};

RequireUserNotToBeGuest.propTypes = {
  children: oneOfType([node, func]).isRequired
};

export default RequireUserNotToBeGuest;
